import { Theme } from '@mssgme/ui';

export const resolveBlockTheme = (baseTheme, block) => {
    return Theme.resolve(`blocks.${block.kind.toLowerCase()}`, baseTheme, block.theme);
};
